import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import {
  Form,
  Divider,
  Button,
  Input,
  Header,
  Message,
  Dimmer,
  Loader
} from 'semantic-ui-react';
import './style.css';

const LoginForm = (props) => {
  return(
    <div className="login-form">
      <Dimmer inverted={true} active={props.loading}>
        <Loader />
      </Dimmer>
      <div className='form-container'>
      {/* <Segment padded> */}
        <Header as='h2'>Hi! Please login.</Header>
        <Form className="buttons-container">
          <Form.Field>
            <Button
              fluid
              labelPosition='left'
              icon='google plus'
              onClick={() => props.loginGoogle()}
              color='google plus'
              content='Continue with Google'
            />
          </Form.Field>
          <Form.Field>
            <Button
              fluid
              labelPosition='left'
              icon='facebook'
              onClick={() => props.loginFacebook()}
              color='facebook'
              content='Continue with Facebook'
            />
          </Form.Field>
        </Form>
        <Divider horizontal>Or</Divider>
        <Form
          onSubmit={() => props.loginUser(props.email, props.password)}
          error={ props.error ? true : false }>
          <Form.Field>
            <Input
              icon='mail outline'
              iconPosition='left'
              placeholder='Email'
              onChange={(e, data) => props.onEmailChange(data.value)}
              value={props.email}
            />
          </Form.Field>
          <Form.Field>
            <Input
              icon='lock'
              iconPosition='left'
              placeholder='Password'
              type='password'
              onChange={(e, data) => props.onPasswordChange(data.value)}
              value={props.password}
            />
          </Form.Field>
          <Message error content={props.error}/>
          <Form.Field>
            <Button fluid type="submit" primary> Sign In </Button>
          </Form.Field>
        </Form>
      </div>
      {/* </Segment> */}
    </div>
  );
}

LoginForm.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  loginFacebook: PropTypes.func.isRequired,
  loginGoogle: PropTypes.func.isRequired,
  loginUser: PropTypes.func.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
}

LoginForm.defaultProps = {
  loading: false,
  error: ''
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/LoginForm/index.js